import {
  ADS_PAGE_PATH,
  ENABLE_ADS_BY_ANCHOR_PAGE,
} from 'client/screens/AdsByAnchorScreen/constants';
import { paths } from 'client/shared/Paths';
import {
  clickedCreateEpisodeButton,
  clickedQuickUploadButton,
} from 'components/PublicWebsiteNav/events';

export const adsByAnchorLink = ENABLE_ADS_BY_ANCHOR_PAGE
  ? [
      {
        type: 'link',
        label: 'Ads by Anchor',
        key: 'ads',
        to: ADS_PAGE_PATH,
      },
    ]
  : [];

export const SIGNED_OUT_LINKS = [
  {
    type: 'link',
    label: 'Features',
    key: 'features',
    to: paths.anchor.features,
  },
  {
    type: 'link',
    label: 'Switch to Anchor',
    key: 'switch',
    to: paths.anchor.switch,
  },
  ...adsByAnchorLink,
  {
    type: 'link',
    label: 'Blog',
    key: 'blog',
    href: paths.blog.home,
    openInNewTab: true,
  },
];

// These are normally in the footer, but for narrow screens, we only keep Legal there.
export const SECONDARY_MOBILE_LINKS = [
  {
    type: 'link',
    label: 'Careers',
    key: 'careers',
    href: paths.spotify.jobs.creationPlatform,
    target: '_blank',
  },
  {
    type: 'link',
    label: 'Help',
    key: 'help',
    href: paths.getHelpPage('home'),
    target: '_blank',
  },
];

// TODO: add back episodes link when the episodes page is ready
export const SIGNED_IN_LINKS = [
  {
    type: 'link',
    label: 'Network',
    key: 'network',
    to: '/dashboard/network',
  },
  {
    type: 'link',
    label: 'Dashboard',
    key: 'dashboard',
    to: '/dashboard',
  },
  {
    type: 'link',
    label: 'Episodes',
    key: 'episodes',
    to: '/dashboard/episodes',
  },
  {
    type: 'link',
    label: 'Money',
    key: 'money',
    to: '/dashboard/money',
    notificationBadge: 'DollarSignIcon',
  },
];

export const ACCOUNT_MENU_ITEMS = [
  {
    type: 'link',
    label: 'Update settings',
    icon: {
      type: 'GearIcon',
      iconColor: '#c9cbcd',
      backgroundColor: 'transparent',
      width: 18,
      padding: 0,
    },
    to: '/dashboard/podcast/edit',
  },
  {
    type: 'link',
    label: 'Help',
    icon: {
      type: 'QuestionMarkIcon',
      iconColor: '#ffffff',
      backgroundColor: 'gray',
      width: 18,
      padding: 3,
    },
    target: '_blank',
    href: paths.getHelpPage('home'),
  },
];

export const getNewEpisodeMenuItems = (
  isVideoPodcaster: boolean,
  onClickQuickUpload: () => void
) => {
  return [
    {
      type: 'link',
      label: 'Create an episode',
      description: 'Record, edit, and enhance audio',
      icon: {
        type: 'MicIcon',
        iconColor: '#000000',
        backgroundColor: 'transparent',
        width: 20,
        padding: 0,
      },
      to: '/dashboard/episode/new',
      onClick: () => {
        clickedCreateEpisodeButton();
      },
    },
    {
      type: 'separator',
    },
    {
      type: 'item',
      label: 'Quick upload',
      description: isVideoPodcaster
        ? 'Create an episode from an audio or video file'
        : 'Publish an episode from an existing file',
      icon: {
        type: 'UploadIcon',
        iconColor: '#c9cbcd',
        backgroundColor: 'transparent',
        width: 20,
        padding: 0,
      },
      onClick: () => {
        clickedQuickUploadButton();
        onClickQuickUpload();
      },
    },
  ];
};
